// JavaScript source code
import Cookies from 'js-cookie';
import { Dimensions } from 'react-native';

export const CookiesStatus = Object.freeze({
    allCookies: 1,
    rejectCookies: 2
})

export function IsDev() {
    return process.env.NODE_ENV === "development" || Cookies.get("DevOverride") !== undefined;
}

export async function GetAccessToken() {
    if (Cookies.get("LudareAccessToken") !== undefined && Cookies.get("LudareAccessToken") !== "undefined") {
        return Cookies.get("LudareAccessToken");
    }
    if ((Cookies.get("LudareAccessToken") === undefined || Cookies.get("LudareAccessToken") === "undefined") && Cookies.get("LudareRefreshToken") !== undefined) {
        return new Promise((resolve, reject) => {
            const reqOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ 'token': Cookies.get("LudareRefreshToken"), 'authType': "REFRESH_TOKEN_AUTH" })
            };

            fetch(process.env.REACT_APP_NODE_ADDRESS + '/Login', reqOptions)
                .then((res) => res.json())
                .then((data) => {
                    if (data.success === false) {
                        resolve(undefined);
                    }

                    console.log(data);
                    SetTokens(data);
                    resolve(Cookies.get("LudareAccessToken"));
                });
        });
    }
}
export function SetTokens(data) {
    console.log(data.message);
    Cookies.set("LudareAccessToken", data.message.accessToken, { expires: 1/24, path: '/' });
    Cookies.set("LudareRefreshToken", data.message.refreshToken, { expires: 30, path: '/' });
}

export function CheckUsername(username, result, resultString) {
    const reqOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 'username': username })
    };

    fetch(process.env.REACT_APP_NODE_ADDRESS + '/CheckUsername', reqOptions)
        .then((res) => res.json())
        .then((data) => {
            if (data.success === false) {
                return;
            }
            result(data.result);
            if (data.result === true) {
                resultString("Username is not taken");
            }
            else {
                resultString("Username is already taken");
            }
        });
}

const specialCharacters = ['^', '$', '*', '.', '[', ']', '{', '}', '(', ')', '?', '-', '"', '!', '@', '#', '%', '&', '/', '\\', ',', '>', '<', "'", ':', ';', '|', '_', '~', '`', '+', '='];

export function PasswordCheck( testPassword, setLowerCheck, setCapitalCheck, setSpecialCheck, setNumberCheck, setLengthCheck) {
    let tempLength, tempCapital, tempLower, tempSpecial, tempNumber = false;
    let i;

    for (i = 0; testPassword !== null && i < testPassword.length; i++) {
        const test = testPassword.charAt(i)
        if (test >= 'a' && test <= 'z') tempLower = true;
        if (test >= 'A' && test <= 'Z') tempCapital = true;
        if (specialCharacters.includes(test)) tempSpecial = true;
        if (test >= '0' && test <= '9') tempNumber = true;
    }
    if (i >= 8) tempLength = true;
    setLowerCheck(tempLower);
    setCapitalCheck(tempCapital);
    setSpecialCheck(tempSpecial);
    setNumberCheck(tempNumber);
    setLengthCheck(tempLength);
}

export async function GetGame(gameId) {
  const req = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ gameId: gameId })
    }
  try {
    const response = await fetch(process.env.REACT_APP_NODE_ADDRESS + '/GetGameInfo', req);
    const data = await response.json();

    if (data.success) {
      //console.log(data)
      return data;
    } else {
      throw new Error('Failed to retrieve game info');
    }
  } 
  catch (error) {
    //console.error('Error fetching game info:', error);
    return null;
  }
}

export async function GetDeveloperInfo(developerId) {
  const req = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ developerId })
    }
  try {
    const response = await fetch(process.env.REACT_APP_NODE_ADDRESS + '/GetDeveloperInfo', req);
    const data = await response.json();

    if (data.success) {
      return data;
    } else {
      throw new Error('Failed to retrieve developer info');
    }
  } 
  catch (error) {
    console.error('Error fetching developer info:', error);
    return null;
  }
}

export async function GetTagInfo(tagIds) {

    if (IsValid(tagIds) === false) return [];

  const idArray = tagIds.split(',');

  const req = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ ids: idArray })
  }

  try {
    const response = await fetch(process.env.REACT_APP_NODE_ADDRESS + '/GetTagInfo', req);
    const data = await response.json();

      // Extract the `id` values into an array
      if (data.success === true) {
          const nameArray = data.message.map(tag => tag.TagName);

          //console.log('Response data:', nameArray);

          return nameArray;
      }
      else {
          return null;
      }
  }
  catch (error) {
    //console.error('Error updating game info:', error);
    return null;
  }
}

export function IsValid(item) {
    return item !== undefined && item !== null;
}

export function FetchAccountInfo(setAccountInfo) {

    var URL = process.env.REACT_APP_NODE_ADDRESS + "/GetAccountInfo";
    GetAccessToken().then((token) => {

        if (IsValid(token) !== true) return;
        const reqOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ 'token': token })
        };

        fetch(URL, reqOptions)
            .then((res) => res.json())
            .then((data) => { setAccountInfo(data.message); });
    });
}

export function GetPaymentMethods(accountInfo, setPaymentMethods) {
    if (IsValid(accountInfo) === false) {
        return undefined;
    }

    const idReqOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 'customer': accountInfo.StripeId })
    };

    fetch(process.env.REACT_APP_NODE_ADDRESS + "/GetPaymentMethods", idReqOptions)
        .then((res) => res.json())
        .then((data) => {
            if (data.success === true) {
                setPaymentMethods(data.paymentMethods);

            }
            else {
                setPaymentMethods(undefined);
            }
        });
}

export function GetSubscription(accountInfo, setSubscription) {
    const idReqOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 'customer': accountInfo.StripeId })
    };

    fetch(process.env.REACT_APP_NODE_ADDRESS + "/GetSubscription", idReqOptions)
        .then((res) => res.json())
        .then((data) => {
            console.log(data);
            if (data.success) {
                setSubscription(data.message);
            }
            else {
                setSubscription(null);
            }
        });
}

export function GetAuthStatus() {
    return Cookies.get("LudareRefreshToken") !== undefined;
}

export function IsMobile() {
    //console.log(Dimensions.get('window').width);
    return Dimensions.get('window').width < 500;
}